var _polygon, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPencil({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14 14",
    height: 14,
    className: "svg-symbol icon-edit ",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "fill",
    points: "0.9,13.6 3.7,12.6 2.7,11.6 1.6,10.6"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "fill",
    x: 1.6,
    y: 4.4,
    width: 12.5,
    height: 2.9,
    transform: "matrix(0.6757 -0.7372 0.7372 0.6757 -1.7648 7.7007)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.6ffb53b8b29d47a1ca625f1deba89495.svg";
export { ForwardRef as ReactComponent };